function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import PropTypes from "prop-types";
import Linkify from "react-linkify";
// Material imports
import Typography from "@mui/material/Typography";
import makeStyles from "@mui/styles/makeStyles";
import ClampedDialogueBody from "./ClampedDialogueBody";
export const useDialogueBodyStyles = makeStyles(theme => ({
  linkify: {
    display: "flex"
  },
  dialogueBody: {
    wordWrap: "break-word",
    whiteSpace: "pre-wrap",
    overflow: "hidden",
    wordBreak: "break-word",
    "& a": {
      color: theme.palette.link
    },
    textAlign: "left",
    direction: "ltr"
  },
  dialogueBodyRtl: {
    textAlign: "right",
    direction: "rtl"
  }
}));
const DialogueBody = ({
  body,
  textStyling,
  lineClamp,
  linkify,
  isRtl,
  ...rest
}) => {
  const classes = useDialogueBodyStyles();
  const child = lineClamp ? /*#__PURE__*/React.createElement(ClampedDialogueBody, _extends({
    body: body,
    textStyling: textStyling
  }, rest)) : /*#__PURE__*/React.createElement(Typography, {
    classes: {
      root: textStyling
    },
    component: "div",
    variant: "body2",
    tabIndex: 0,
    className: `${classes.dialogueBody} ${isRtl ? classes.dialogueBodyRtl : ""}`
  }, body);
  if (!linkify) {
    return /*#__PURE__*/React.createElement("div", {
      className: classes.linkify
    }, child);
  }
  return /*#__PURE__*/React.createElement(Linkify, {
    properties: {
      target: "_blank",
      onClick: e => e.stopPropagation()
    },
    className: classes.linkify
  }, child);
};
export default DialogueBody;
DialogueBody.propTypes = {
  body: PropTypes.string.isRequired,
  textStyling: PropTypes.string,
  lineClamp: PropTypes.bool,
  linkify: PropTypes.bool,
  isRtl: PropTypes.bool
};
DialogueBody.defaultProps = {
  textStyling: "",
  lineClamp: false,
  linkify: true,
  isRtl: false
};